/* eslint-disable react/destructuring-assignment */
import {
  Paper, ToggleButton, ToggleButtonGroup,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const PrimaryToggleButtonGroupStyles = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    margin: theme.spacing(0.5),
    border: 0,
    '&.Mui-disabled': {
      border: 0,
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

export const PrimaryToggleButtonGroup = (props: any) => (
  <Paper
    elevation={0}
    sx={{
      display: 'flex',
      border: (theme) => `1px solid ${theme.palette.grey.A400}`,
      flexWrap: 'wrap',
    }}
  >
    <PrimaryToggleButtonGroupStyles
      {...props}
      fullWidth
      exclusive
    >
      {props.children}
    </PrimaryToggleButtonGroupStyles>
  </Paper>
);

const PrimaryToggleButtonStyles = styled(ToggleButton)(({ theme }) => ({
  textTransform: 'none',
  backgroundColor: theme.palette.action.disabledBackground,
  color: theme.palette.text.primary,
  padding: '5px',
  '&:hover': {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.primary,
  },
  '&.Mui-selected': {
    color: theme.palette.text.disabled,
    backgroundColor: theme.palette.primary.main,
  },
  '&.Mui-selected:hover': {
    color: theme.palette.text.disabled,
    backgroundColor: theme.palette.primary.main,
  },
}));

export const PrimaryToggleButton = (props: any) => (
  <PrimaryToggleButtonStyles {...props}>
    {props.children}
  </PrimaryToggleButtonStyles>
);
